import { render, staticRenderFns } from "./EvidenceInfo.vue?vue&type=template&id=0c9963bc&"
import script from "./EvidenceInfo.vue?vue&type=script&lang=js&"
export * from "./EvidenceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports